import { render, staticRenderFns } from "./churuDb.vue?vue&type=template&id=d01908c0&scoped=true"
import script from "./churuDb.vue?vue&type=script&lang=js"
export * from "./churuDb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01908c0",
  null
  
)

export default component.exports